// DS: CO0.2, CO0.2M
import React from 'react';
import DeviationGrid3x3 from './layouts/DeviationGrid3X3';
import SingleColumnTextual from './layouts/SingleColumnTextual';
import DeviationMosaic from './layouts/DeviationMosaic';
import TierList from './layouts/TierList';
import DeviationMobileList from './layouts/DeviationMobileList';
import Groups from './layouts/Groups';
import Collections from './layouts/Collections';
import Dealer from './layouts/Dealer';
import MonetizationBlock from './layouts/MonetizationBlock';
import AdoptableInfo from './layouts/AdoptableInfo';
import PcpInfo from './layouts/PcpInfo';
import Users from './layouts/Users';
import Topics from './layouts/Topics';
import Ad from './layouts/Ad';
const genericLayouts = {
    1: DeviationGrid3x3,
    2: SingleColumnTextual,
    3: DeviationMosaic,
    4: TierList,
    5: DeviationMobileList
};
const uniqueLayouts = {
    subscription_promotion: MonetizationBlock,
    monetization_promotion: MonetizationBlock,
    monetization_promotion_tier: MonetizationBlock,
    monetization_promotion_commission: MonetizationBlock,
    monetization_promotion_premium_gallery: MonetizationBlock,
    monetization_promotion_adoptable: MonetizationBlock,
    adoptable_info: AdoptableInfo,
    pcp_info: PcpInfo,
    groups: Groups,
    collections: Collections,
    dealer: Dealer,
    users: Users,
    topics: Topics,
    ad_top: Ad,
    ad_btf: Ad
};
function getBlockComponent(block) {
    if (block.layout === 0) {
        return uniqueLayouts[block.contentType];
    }
    return genericLayouts[block.layout];
}
const SidebarBlock = (props)=>{
    const BlockComponent = getBlockComponent(props.block);
    if (BlockComponent) {
        return /*#__PURE__*/ React.createElement(BlockComponent, props);
    }
    return null;
};
SidebarBlock.displayName = 'SidebarBlock';
export default SidebarBlock;
